import { createRouter, createWebHistory } from 'vue-router'
import SignIn from './components/SignIn.vue'
import Home from './components/Home.vue'
import { UserManager, WebStorageStateStore } from 'oidc-client'

const userManager = new UserManager({
      authority: "https://www.honex.com.ua/identityservice/",
      client_id: "avn-web",
      post_logout_redirect_uri: window.location.origin,
      redirect_uri: window.location.origin + "/callback",
      response_type: "code",
      scope: "openid",
      userStore: new WebStorageStateStore({
        store: window.sessionStorage
      })
    })

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/signin',
      component: SignIn
    },
    {
      path: '/callback',
      name: 'callback',
      beforeEnter: async (to, from, next) => {
        try {
          // Обробка OIDC callback
          await userManager.signinRedirectCallback()
        } catch (error) {
          console.error('Помилка callback:', error)
        } finally {
          next('/')
        }
      }
    }
  ]
})

export { userManager }